export default __webpack_public_path__ + "static/media/0.3af9e960.jpg";